export const setState = (state) => ({
    type: "STATE",
    state
})